module.exports = __webpack_public_path__ + "img/sec3mob.044ce542.png";